import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  public tabs = 0;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) {}

   changeOptOutTaxReceipt(reqData){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(reqData))}`
    ];
    return this.http.post('/api/org/setTaxReceiptOptout', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  changeRefundToggle(orgId, enable) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        orgId,
        enable
      }))}`
    ];
    return this.http.post('/api/admin/org/refund/enable', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  onSaveField(reqData,url){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(reqData))}`
    ];
    return this.http.post(url, _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  isEmailAvailable(email){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({email}))}`
    ];
    return this.http.post('api/org/email/available', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  onChangeOrganizationPassword(reqData){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `old=${reqData.old_pass}`,
      `new=${reqData.new_pass}`
    ];
    return this.http.post('/api/change_password', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  onChangeAccountPassword(reqData){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `old=${reqData.old_pass}`,
      `new=${reqData.new_pass}`
    ];
    return this.http.post('/api/admin/change_password', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

}
